export default __webpack_public_path__ + "static/media/gravit8_logo (1).41820ffc.svg";